import { makeAutoObservable } from "mobx";
import { assertState } from "../../core";
import { t, translate } from "../../I18n";
export class EnabledCoupon {
    constructor(params) {
        this.type = "Enabled";
        this.promotionService = params.promotionService;
        this.inCartPromotionTypes = params.inCartPromotionTypes;
        this._couponPromotion = null;
        this._state = {
            type: "Init",
            showForm: () => this.setCouponStateForm(),
        };
        makeAutoObservable(this);
    }
    static async fromStorageData(params) {
        const enabledCoupon = new EnabledCoupon({
            promotionService: params.promotionService,
            inCartPromotionTypes: params.inCartPromotionTypes,
        });
        if (params.couponCode !== null) {
            enabledCoupon.setCouponStateForm();
            await enabledCoupon.submitCoupon(params.couponCode);
        }
        return enabledCoupon;
    }
    get state() {
        return this._state;
    }
    get couponPromotion() {
        return this._couponPromotion;
    }
    setCouponStateInit() {
        this._state = {
            type: "Init",
            showForm: () => this.setCouponStateForm(),
        };
    }
    setCouponStateForm() {
        this._state = {
            type: "Form",
            isLoading: false,
            errorMessage: null,
            submit: (couponCode) => this.submitCoupon(couponCode),
        };
    }
    setCouponStateLoading() {
        assertState(this._state, "Form");
        this._state = {
            ...this._state,
            isLoading: true,
            errorMessage: null,
        };
    }
    setCouponStateError(errorMessage) {
        assertState(this._state, "Form");
        this._state = {
            ...this._state,
            isLoading: false,
            errorMessage,
        };
    }
    setCouponStateApplied(coupon) {
        assertState(this._state, "Form");
        this._state = {
            type: "Applied",
            description: coupon.code.value,
            source: coupon.source,
            remove: () => {
                this.removeCoupon();
                this.setCouponStateForm();
            },
        };
    }
    async submitCoupon(couponCode) {
        this.setCouponStateLoading();
        try {
            const result = await this.promotionService.getCoupon(couponCode);
            if (result === null) {
                this.setCouponStateError(translate(t.coupon.invalid));
            }
            else {
                this.setCouponStateApplied(result.coupon);
                this.addCoupon(result.coupon, result.promotion);
            }
        }
        catch (error) {
            this.setCouponStateError(translate(t.coupon.fetch_error));
            console.error(error);
        }
    }
    addCoupon(coupon, promotion) {
        this._couponPromotion = promotion;
        this.inCartPromotionTypes.setCoupon(coupon);
    }
    removeCoupon() {
        this._couponPromotion = null;
        this.inCartPromotionTypes.setCoupon(null);
    }
    clear() {
        this.removeCoupon();
        this.setCouponStateInit();
    }
}
